import * as ActionTypes from '../../constants/ActionTypes';

const initialState = {
	application: null,
	hkust_points: [],
	favorite_destinations: [],
	staffs: [],
	booking_guidelines: null,
	previous_bookings: [],
	loading: false,
	loadingTitles: false,
	loadingStaffs: false,
	loadingSubmit: false,
	loadingInstantSubmit: false,
	loadingFavoriteLocationSubmit: false,
	loadingUpdate: false,
	loadingStatus: false,
	loadingCancel: false
};

export default function reducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.GET_BOOKING_GUIDELINES_REQUEST:
		case ActionTypes.GET_BOOKING_GUIDELINES_ERROR:
		case ActionTypes.GET_BOOKING_GUIDELINES_SUCCESS:
		case ActionTypes.SUBMIT_START_APPLICATION_REQUEST:
		case ActionTypes.SUBMIT_START_APPLICATION_ERROR:
		case ActionTypes.SUBMIT_START_APPLICATION_SUCCESS:
		case ActionTypes.SUBMIT_APPLICATION_FAVORITE_DESTINATION_REQUEST:
		case ActionTypes.SUBMIT_APPLICATION_FAVORITE_DESTINATION_ERROR:
		case ActionTypes.SUBMIT_APPLICATION_FAVORITE_DESTINATION_SUCCESS:
		case ActionTypes.SUBMIT_INSTANT_BOOKING_REQUEST:
		case ActionTypes.SUBMIT_INSTANT_BOOKING_ERROR:
		case ActionTypes.SUBMIT_INSTANT_BOOKING_SUCCESS:
		case ActionTypes.GET_APPLICATION_BY_ID_REQUEST:
		case ActionTypes.GET_APPLICATION_BY_ID_ERROR:
		case ActionTypes.GET_APPLICATION_BY_ID_SUCCESS:
		case ActionTypes.GET_APPLICATION_HKUST_POINTS_REQUEST:
		case ActionTypes.GET_APPLICATION_HKUST_POINTS_ERROR:
		case ActionTypes.GET_APPLICATION_HKUST_POINTS_SUCCESS:
		case ActionTypes.GET_APPLICATION_FAVORITE_DESTINATIONS_REQUEST:
		case ActionTypes.GET_APPLICATION_FAVORITE_DESTINATIONS_ERROR:
		case ActionTypes.GET_APPLICATION_FAVORITE_DESTINATIONS_SUCCESS:
		case ActionTypes.GET_APPLICATION_STAFFS_REQUEST:
		case ActionTypes.GET_APPLICATION_STAFFS_SUCCESS:
		case ActionTypes.GET_APPLICATION_STAFFS_ERROR:
		case ActionTypes.GET_APPLICATION_PREVIOUS_BOOKINGS_REQUEST:
		case ActionTypes.GET_APPLICATION_PREVIOUS_BOOKINGS_ERROR:
		case ActionTypes.GET_APPLICATION_PREVIOUS_BOOKINGS_SUCCESS:
		case ActionTypes.SUBMIT_APPLICATION_REQUEST:
		case ActionTypes.SUBMIT_APPLICATION_ERROR:
		case ActionTypes.SUBMIT_APPLICATION_SUCCESS:
		case ActionTypes.UPDATE_APPLICATION_STATUS_REQUEST:
		case ActionTypes.UPDATE_APPLICATION_STATUS_SUCCESS:
		case ActionTypes.UPDATE_APPLICATION_STATUS_ERROR:
		case ActionTypes.CANCEL_ALL_TRIPS_REQUEST:
		case ActionTypes.CANCEL_ALL_TRIPS_ERROR:
		case ActionTypes.CANCEL_ALL_TRIPS_SUCCESS:
			return {
				...state,
				...action.payload
			};
		case ActionTypes.RESET_APPLICATION_META:
			return {
				...state,
				meta: null
			};
		case ActionTypes.RESET_APPLICATION_PAGE:
			return {
				...initialState
			};
		default:
			return state;
	}
}
